import { Injectable } from '@angular/core';
import { VexLayoutService } from '@vex/services/vex-layout.service';
import { NavigationItem } from './navigation-item.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { CategoriesService } from '../../pages/categories/categories.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class NavigationLoaderService {
  private readonly _items: BehaviorSubject<NavigationItem[]> =
    new BehaviorSubject<NavigationItem[]>([]);

  get items$(): Observable<NavigationItem[]> {
    return this._items.asObservable();
  }

  constructor(private readonly layoutService: VexLayoutService, private categoriesService: CategoriesService, private translate: TranslateService) {
    const path = window.location.pathname;
    if (path.includes('/admin')) {
      this.loadAdminPage()
    }else{
      this.loadHomePage();
    }
  }
  loadHomePage(){
    this.categoriesService.getCategories().subscribe(res => {
      // res.results is a list of pages
      const categories = res.results || [];

      // Map each page into a "link" item
      const pageLinks = categories.filter((cate:any)=>cate.parent_cate_id == null).map((cate:any) => ({
        type: 'link',
        label: cate.label,
        route: 'categories/'+cate.id,
        icon: cate.icon,
        parent_cate_id: cate.parent_cate_id,
        id: cate.id
      }));

      // Build your full menu object
      const menu:any[] = [{
        type: 'subheading',
        label: this.translate.instant('WELCOME'),
        children: [
          {
            type: 'link',
            label: this.translate.instant('HOME_PAGE'),
            route: '/',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          }
        ]
      }, {
        type: 'subheading',
        label: this.translate.instant('PAGES'),
        children: pageLinks
      }];
      this._items.next(menu);

    });
    // this.loadNavigation();
  }
  loadAdminPage() {
    setTimeout(()=>{this.loadNavigation();},300)
  }

  loadNavigation(): void {
    const pages: any[] = [
      {
        type: 'subheading',
        label: this.translate.instant('WELCOME'),
        children: [
          {
            type: 'link',
            label: this.translate.instant('HOME_PAGE'),
            route: '/',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          }
        ]
      },
      {
        type: 'subheading',
        label: this.translate.instant('TABLES'),
        children: [
          {
            type: 'link',
            label: this.translate.instant('USERS'),
            route: '/admin/tables/users',
            icon: 'mat:person'
          },
          // {
          //   type: 'link',
          //   label: this.translate.instant('PAGES'),
          //   route: '/admin/tables/pages',
          //   icon: 'mat:pages'
          // },
          // {
          //   type: 'link',
          //   label: this.translate.instant('CATEGORIES'),
          //   route: '/admin/tables/categories',
          //   icon: 'mat:category'
          // }
        ]
      }]
      this._items.next(pages)

  }
}
